import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./NameAndDescription.module.sass";


// Screens
import SignaturesAndAbsences from "./SignaturesAndAbsences";
import Comment from "./Comment";
import Panel from "./Panel";
// Services
import { showSuccess, showError } from "../../../services/toast.service";
import { sendSignatureInvitations } from "../../../services/signature.service";

const Attendances = ({ session, onUpdateSession }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedAttendances, setSelectedAttendances] = useState([]);
  const [sendingInvitations, setSendingInvitations] = useState(false);
  const [sessionData, setSessionData] = useState({
    title: '',
    description: '',
    start_date: '',
    end_date: '',
    formation_id: null,
    teacher_id: null,
    participants_id: [],
    status: 'Prévu',
    session_type: '',
    room: ''
  });

  // Initialiser les données de session depuis les props
  useEffect(() => {
    if (session) {
      setSessionData({
        title: session.title || '',
        description: session.description || '',
        start_date: session.start_date || '',
        end_date: session.end_date || '',
        formation_id: session.formation_id || null,
        teacher_id: session.teacher_id || null,
        participants_id: session.participants_id || [],
        status: session.status || 'Prévu',
        session_type: session.session_type || '',
        room: session.room || ''
      });
    }
  }, [session]);

  const handleInputChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  // Validation des champs requis
  const validateForm = () => {
    const errors = [];

    if (!sessionData.title?.trim()) {
      errors.push('Le titre de la session est requis');
    }

    if (!sessionData.start_date) {
      errors.push('La date de début est requise');
    }

    if (!sessionData.end_date) {
      errors.push('La date de fin est requise');
    }

    if (!sessionData.teacher_id) {
      errors.push('Un professeur doit être sélectionné');
    }

    if (!sessionData.participants_id || sessionData.participants_id.length === 0) {
      errors.push('Au moins un étudiant doit être sélectionné');
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validation avant soumission
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      const errorMessage = 'Veuillez corriger les erreurs suivantes:\n' + validationErrors.join('\n');
      showError(errorMessage);
      setError(errorMessage);
      setLoading(false);
      return;
    }

    try {
      console.log('Données de session à mettre à jour:', sessionData);
      await onUpdateSession(sessionData);
      // Le message de succès est déjà affiché dans handleUpdateSession du parent
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour la session formation: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Fonctions pour gérer les attendances sélectionnées
  const handleRemoveSelected = async (selectedIds) => {
    if (!selectedIds.length) return;

    try {
      // Logique de suppression des attendances sélectionnées
      console.log('Suppression des attendances:', selectedIds);
      // TODO: Implémenter la suppression via le service
      setSelectedAttendances([]);
      showSuccess('Attendances supprimées avec succès.');
    } catch (error) {
      showError('Erreur lors de la suppression des attendances.');
      console.error(error);
    }
  };

  const handleClearSelection = () => {
    setSelectedAttendances([]);
  };

  const handleSendSignatureInvitations = async (selectedIds) => {
    if (!selectedIds.length) return;

    setSendingInvitations(true);
    try {
      await sendSignatureInvitations(selectedIds);
      showSuccess('Invitations de signature envoyées avec succès!');
      setSelectedAttendances([]);
    } catch (error) {
      showError('Erreur lors de l\'envoi des invitations.');
      console.error(error);
    } finally {
      setSendingInvitations(false);
    }
  };

  // Vérifier si le formulaire est valide pour activer/désactiver le bouton
  const isFormValid = () => {
    return validateForm().length === 0;
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <SignaturesAndAbsences
            session={session}
            selectedAttendances={selectedAttendances}
            onSelectAttendance={(id, isSelected) => {
              if (isSelected) {
                setSelectedAttendances([...selectedAttendances, id]);
              } else {
                setSelectedAttendances(selectedAttendances.filter(attendanceId => attendanceId !== id));
              }
            }}
            onSelectAll={(isSelected, allIds) => {
              if (isSelected) {
                setSelectedAttendances([...allIds]);
              } else {
                setSelectedAttendances([]);
              }
            }}
          />
          <Comment
            session={session}
          />
        </div>
      </div>
      <Panel
        selectedAttendances={selectedAttendances}
        onRemoveSelected={handleRemoveSelected}
        onClearSelection={handleClearSelection}
        onSendSignatureInvitations={handleSendSignatureInvitations}
        sendingInvitations={sendingInvitations}
      />
    </>
  );
};

export default Attendances;
